import {
  type CatalogItemTagIcon,
  type CatalogItemTagVariant,
  CatalogItemTagVariants,
} from '../../value-objects/CatalogItemTag'
import { CatalogItemTagGlyph } from '../CatalogItemTagGlyph'
import { CatalogItemTagIconStyled } from './styles/CatalogItemTagIconStyled'
import { CatalogItemTagLabelStyled } from './styles/CatalogItemTagLabelStyled'
import { CatalogItemTagLayoutStyled } from './styles/CatalogItemTagLayoutStyled'
import { CatalogItemTagLogoStyled } from './styles/CatalogItemTagLogoStyled'

const TAG_ICON_SIZE = 16

export interface ICatalogItemTagProps {
  icon?: CatalogItemTagIcon
  text: string
  variant?: CatalogItemTagVariant
  logoUrl?: string
}

export const CatalogItemTag = ({
  icon,
  text,
  variant = CatalogItemTagVariants.DEFAULT,
  logoUrl,
}: ICatalogItemTagProps) => {
  const renderLeadingAsset = () => {
    if (logoUrl) return <CatalogItemTagLogoStyled src={logoUrl} alt='' />
    if (!icon) return null
    return (
      <CatalogItemTagIconStyled $size={TAG_ICON_SIZE} aria-hidden>
        <CatalogItemTagGlyph icon={icon} size={TAG_ICON_SIZE} />
      </CatalogItemTagIconStyled>
    )
  }

  return (
    <CatalogItemTagLayoutStyled
      $variant={variant}
      $hasLeadingAsset={Boolean(logoUrl || icon)}
    >
      {renderLeadingAsset()}
      <CatalogItemTagLabelStyled>{text}</CatalogItemTagLabelStyled>
    </CatalogItemTagLayoutStyled>
  )
}
